import React, { ReactNode } from "react";

import "./charts.scss";
import {
  LocalLoader,
  LocalLoaderWrapper,
} from "../loader/localLoader/LocalLoader";
import { DrilldownLink } from "./widgets/drilldownLink/DrilldownLink";
import { DrilldownKeys } from "../../helpers/reports.helper.types";

interface WidgetProps {
  drilldown: DrilldownKeys;
  className: string;
  children: ReactNode;
  isLoading: boolean;
}

const Widget = ({ drilldown, className, children, isLoading }: WidgetProps) => {
  const widgetClasses = `widget ${className || ""}`;

  return (
    <LocalLoaderWrapper>
      <div className={widgetClasses}>
        {isLoading && <LocalLoader />}
        {children}
        <DrilldownLink drilldown={drilldown} />
      </div>
    </LocalLoaderWrapper>
  );
};

export default Widget;
